import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, formatMoney, getInlineLoader } from "../Helpers";
import {
	STR_AMOUNT,
	STR_AMOUNT_2,
	STR_AVAILABLE_HOTELS,
	STR_BACK,
	STR_BY_SENDING_LOAN_REQUEST_YOU_AGREE_TO_TERMS,
	STR_CASH,
	STR_CHANGE_PHONE_NUMBER,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_FLOAT,
	STR_FLOAT_LOAN_BALANCE,
	STR_FLOAT_LOAN_LIMIT,
	STR_FLOAT_LOAN_SERVICE,
	STR_INVALID_AMOUNT,
	STR_INVALID_SERVICE_PROVIDER,
	STR_INVALID_TILL,
	STR_MENU_HOTELS,
	STR_MY_LOANS,
	STR_NO_RECORD,
	STR_NOTIFICATIONS,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_READ_TERMS_CONDITIONS,
	STR_RECENT_REQUESTS,
	STR_REQUEST_AMOUNT_LIMIT,
	STR_REQUEST_FLOAT,
	STR_REQUEST_FLOAT_CASH,
	STR_REQUEST_LOAN,
	STR_SELECT,
	STR_SELECT_2,
	STR_SELECT_REQUEST_TYPE,
	STR_SERVICE_PROVIDER,
	STR_SUBMIT,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_SUCCESS,
	STR_TILL_NUMBER,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdArrowCircleLeft, MdArrowCircleRight, MdCheckCircle, MdContactPage, MdInfoOutline, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdSupportAgent, MdTranslate } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import login_bg from '../assets/login_bg.jpg';
import HomeMenu from "./HomeMenu";
import WelcomeSlider from '../ones/WelcomeSlider';
import EditAgentProfile from "./EditAgentProfile";
import OpSuccessWidget from "../ones/OpSuccessWidget";
import MySubscription from "./MySubscription";
import ProfileVerification from "./ProfileVerification";
import OneFloatLoan from "../ones/OneFloatLoan";
import { FiCheckSquare } from "react-icons/fi";

export default function FloatLoanService(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	
	const [amountRequested, setAmountRequested] = useState(0);
	const [till, setTill] = useState(null);
	const [opSuccessful, setOpSuccessful] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getCurrentUserData(),
			appContext.getSystemParams(),
			appContext.getMyFloatLoans(),
		])
		setReady(true);
	}

	function resetForm() {
		setAmountRequested(0);
		setTill("");
	}

	async function submit() {
		if(!isNaN(amountRequested) && Number(amountRequested) > 0) {
			if(till) {
				setLoading(true);
				await callApi(
					'submit-float-loan-request',
					{
						amountRequested,
						till: JSON.stringify(till),
					}
				).then((response) => {
					if(response.status === 1) {
						setOpSuccessful(true);
					} else {
						appContext.tellError(response.msg)
					}
				})
				setLoading(false);
			} else {
				appContext.tellError(STR_INVALID_TILL[appContext.language]);
			}
			
		} else {
			appContext.tellError(STR_INVALID_AMOUNT[appContext.language]);
		}
	}


	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])


	if (ready) {
		if(appContext.isAgentProfileComplete) {
			if(
				appContext.currentUserData.subscriptionStatus === 'active' &&
				(
					appContext.currentUserData.subscriptionType === 'gold' || appContext.currentUserData.subscriptionType === 'platnum'
				)
			) {
				if(appContext.currentUserData.agentVerificationStatus === 'verified') {
					//..
					return (
						<div
							style={{
								width: "100%",
								height: "100%",
								overflow: "scroll",
								paddingBottom: "calc(var(--topBarHeight) + 40px)",
							}}
							className="mNoScrollBar"
						>
							<div className="container">
			
								<div className="row">
			
									<div className="col-md-12">
										<h6
											className="mSectionTitle"
										>
											{STR_FLOAT_LOAN_SERVICE[appContext.language]}
										</h6>
									</div>

									<div className="col-6">
										<div 
											className="card"
										>
											<div className="card-body">
												<h6
													style={{
														fontSize: "20px"
													}}
													className="font-bold"
												>
													{formatMoney(appContext.currentUserData.floatLoanBalance)}
													<span className="d-block font-bold text-muted" style={{ fontSize: "16px" }}>TZS</span>
												</h6>

												<h6
													style={{
														fontSize: "12px"
													}}
													className="mt-3 font-bold text-secondary"
												>
													{STR_FLOAT_LOAN_BALANCE[appContext.language]}
												</h6>
											</div>
										</div>
									</div>

									<div className="col-6">
										<div 
											className="card"
										>
											<div className="card-body">
												<h6
													style={{
														fontSize: "20px"
													}}
													className="font-bold"
												>
													{formatMoney(appContext.currentUserData.floatLoanLimit)}
													<span className="d-block font-bold text-muted" style={{ fontSize: "16px" }}>TZS</span>
												</h6>

												<h6
													style={{
														fontSize: "12px"
													}}
													className="mt-3 font-bold text-secondary"
												>
													{STR_FLOAT_LOAN_LIMIT[appContext.language]}
												</h6>
											</div>
										</div>
									</div>

									<div 
										className="col-md-12"
									>
										<div className="card">
											<div className="card-body">
												<h6 className="card-title">{STR_REQUEST_LOAN[appContext.language]}</h6>
												<hr/>

												{
													(opSuccessful) ?
													<OpSuccessWidget/>	
													:
													<>
														<div className="mt-4 mb-4">
															<label className="form-label">{STR_AMOUNT[appContext.language]}</label>
															<input
																className="form-control"
																value={amountRequested}
																onChange={(e) => {
																	setAmountRequested(e.target.value)
																}}
															/>
														</div>

														<div className="mt-4 mb-4">
															<label className="form-label">{STR_TILL_NUMBER[appContext.language]}</label>
															<select
																className="form-control"
																value={(till) ? JSON.stringify(till) : ''}
																onChange={(e) => {
																	setTill(JSON.parse(e.target.value))
																}}
															>
																<option value=""></option>
																{
																	JSON.parse(appContext.currentUserData.agentTills).map((item, i) => {
																		return (
																			<option
																				key={i}
																				value={JSON.stringify(item)}
																			>
																				{appContext.getTillTypeName(item.tillType)} - {item.tillNumber}
																			</option>
																		)
																	})
																}
															</select>
														</div>

														<div className="mt-4 mb-4">
															<div className="d-flex mt-2 mb-2 font-semi-bold text-secondary">
																<FiCheckSquare 
																	size={32}
																	style={{
																		flexShrink: 0,
																	}}
																/>
																<h6
																	className=""
																	style={{
																		fontSize: "14px"
																	}}
																>
																	
																	{STR_BY_SENDING_LOAN_REQUEST_YOU_AGREE_TO_TERMS[appContext.language]}
																</h6>
															</div>

															<h6
																className="mb-4 mt-4 text-end font-bold text-primary"
																style={{
																	fontSize: "14px"
																}}
																onClick={() => {
																	appContext.navTo({
																		item: 'view',
																		subItem: 'float_loan_terms_conditions'
																	})
																}}
															>
																
																{STR_READ_TERMS_CONDITIONS[appContext.language]} <MdArrowCircleLeft size={24}/>
															</h6>

															<button
																className="btn btn-block btn-primary btn-padded btn-rounded"
																onClick={submit}
															>
																{STR_SUBMIT[appContext.language]}
															</button>
														</div>
													</>
												}
											</div>
										</div>
									</div>

									<div 
										className="col-md-12"
									>
										<div className="card">
											<div className="card-body">
												<h6 className="card-title">{STR_MY_LOANS[appContext.language]}</h6>
												<hr/>

												{
													(appContext.myFloatLoans && appContext.myFloatLoans.length > 0) ?
													appContext.myFloatLoans.map((item, i) => {
														return (
															<OneFloatLoan key={i} data={item}/>
														)
													})
													:
													<h6>{STR_NO_RECORD[appContext.language]}</h6>
												}
												
											</div>
										</div>
									</div>
								
			
								</div>
			
			
							</div>
						</div>
					)
					
				} else {
					return <ProfileVerification/>
				}
			} else {
				return <MySubscription/>
			}
		} else {
			return <EditAgentProfile/>
		}
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}